// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26ZM9","colBig":"styles_colBig__2tAhC","colSmall":"styles_colSmall__37WIH","shopifyNameWrapper":"styles_shopifyNameWrapper__ESg02"};